/**
 * Frequency pills + search/date filter strip. Pure view.
 *
 * Conceptually separate from `TransactionsHeader` (which owns the
 * primary actions). This card sits below the title row and drives
 * client-side filtering.
 */
import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { FREQUENCY_FILTERS } from './constants';

const TransactionsFilters = ({
  mechanicFilter, setMechanicFilter,
  searchQuery, setSearchQuery,
  startDate, setStartDate,
  endDate, setEndDate,
  clearFilters,
}) => (
  <div className="bg-white border border-[#E2E8F0] rounded-lg p-4 mb-6" data-testid="transaction-filters">
    <div className="flex items-center gap-2 mb-4" data-testid="mechanic-filter-group" aria-label="Frequency filter">
      {FREQUENCY_FILTERS.map((f) => (
        <button
          key={f.value}
          onClick={() => setMechanicFilter(f.value)}
          className={`inline-flex items-center justify-center leading-none px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
            mechanicFilter === f.value ? 'bg-[#0052FF] text-white' : 'bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0]'
          }`}
          data-testid={`mechanic-filter-${f.value}`}
        >
          {f.label}
        </button>
      ))}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      <div>
        <Label className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">Search</Label>
        <Input
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Description or category"
          className="mt-1.5"
          data-testid="search-input"
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">From Date</Label>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1.5"
          data-testid="start-date-filter"
        />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-[0.2em] font-semibold text-[#64748B]">To Date</Label>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1.5"
          data-testid="end-date-filter"
        />
      </div>
      <div className="flex items-end">
        <Button
          onClick={clearFilters}
          className="w-full bg-[#F1F5F9] text-[#020617] hover:bg-[#E2E8F0]"
          data-testid="clear-filters-button"
        >
          Clear Filters
        </Button>
      </div>
    </div>
  </div>
);

export default TransactionsFilters;
